// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38a6abfa","455":"d29d60f9","977":"e9f66f05"}[chunkId] + ".chunk.js";
};